import styled from "styled-components";

export const ErrorBanner = styled.div`
  background-color: #dc3545;
  color: white;
  padding: 1rem;
  margin: 1rem 0;
  text-align: center;
  font-weight: bold;
  font-size: 1.25rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  width: 100%;
`;